import { NotificationBar } from './styled';

import { Text, useTheme, Grid } from '@simplywallst/ui-core';
import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';
import { useTypeformDrawer } from '@/hooks/useTypeformDrawer';
import { Button } from '@simplywallst/ui-core';

interface Props {
  userId: string;
}

const FeedbackAlert = ({ userId }: Props) => {
  const theme = useTheme();
  const showFeedbackForm = useTypeformDrawer('sGGGNAGE', { userId });
  return (
    <NotificationBar>
      <Grid
        templateColumns="auto auto auto"
        gap="8px"
        justifyContent="start"
        alignItems="center"
      >
        <InformationSolid fill={theme.color.whiteRGBA(0.5)} />
        <Text typography="small" color="whiteRGBA" opacity={0.8}>
          New feature: Stock Screener Alerts. Save your screener and we will let
          you know when new stocks match your criteria.{' '}
        </Text>
        <Button
          onClick={showFeedbackForm}
          marginLeft
          styleType="strongLink"
          display="inline"
        >
          Give feedback on screener
        </Button>
      </Grid>
    </NotificationBar>
  );
};
export default FeedbackAlert;
